// extracted by mini-css-extract-plugin
module.exports = {"layout":"jH","content":"jI","a":"jJ","footer":"jK"};